import { render, staticRenderFns } from "./DCOutbound.vue?vue&type=template&id=58098a25&scoped=true"
import script from "./DCOutbound.vue?vue&type=script&lang=js"
export * from "./DCOutbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58098a25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58098a25')) {
      api.createRecord('58098a25', component.options)
    } else {
      api.reload('58098a25', component.options)
    }
    module.hot.accept("./DCOutbound.vue?vue&type=template&id=58098a25&scoped=true", function () {
      api.rerender('58098a25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/ReceiveVolume/DCOutbound.vue"
export default component.exports